// extracted by css-extract-rspack-plugin
export default {"labelWithTooltip":"XT5zW1kfytATQD_o","checkboxLabelTooltips":"Vbq2jnXl0_xU8VK1"};